import * as status from "../LeadStatus/StatusAdministrativeLawCase";
import { StageMetaData } from "../../types/ProductService/ProductService";

import {
  STAGE_ACTION_REQUIRED,
  STAGE_CHECKED,
  STAGE_COMPLETED,
  STAGE_CREATED,
  STAGE_DATA_COMPLETED,
  STAGE_DATA_COMPLETED_LAWFIRM,
  STAGE_EVALUATE_JUDGEMENT,
  STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT,
  STAGE_EXTRAJUDICIAL_REACTION_RECEIVED,
  STAGE_IN_PROGRESS,
  STAGE_LAWSUIT,
  STAGE_LAWSUIT_COMPLETED,
  STAGE_PREPARE_LAWSUIT,
  STAGE_TRIAL,
  STAGE_WAITING_FOR_FEEDBACK,
  stageMetaDataCase as baseStageMetaDataCase,
} from "./StagesCase";
import { ProductUnion } from "../../types/ProductUnion";

const STAGE_ADMINISTRATIVE_PROCEEDINGS = 90;
const STAGE_ADMINISTRATIVE_DECISION_ISSUED = 95;

export {
  STAGE_CREATED,
  STAGE_DATA_COMPLETED,
  STAGE_WAITING_FOR_FEEDBACK,
  STAGE_DATA_COMPLETED_LAWFIRM,
  STAGE_CHECKED,
  STAGE_IN_PROGRESS,
  STAGE_ADMINISTRATIVE_PROCEEDINGS,
  STAGE_ADMINISTRATIVE_DECISION_ISSUED,
  STAGE_COMPLETED,
  STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT,
  STAGE_EXTRAJUDICIAL_REACTION_RECEIVED,
  STAGE_ACTION_REQUIRED,
  STAGE_PREPARE_LAWSUIT,
  STAGE_LAWSUIT,
  STAGE_TRIAL,
  STAGE_EVALUATE_JUDGEMENT,
  STAGE_LAWSUIT_COMPLETED,
};

export const stageMetaDataCase: StageMetaData = {
  ...baseStageMetaDataCase,
  [STAGE_ADMINISTRATIVE_PROCEEDINGS]: {
    label: "Verwaltungsverfahren",
    stage: STAGE_ADMINISTRATIVE_PROCEEDINGS,
    leadStatus: status.STATUS_ADMINISTRATIVE_PROCEEDINGS,
    isActive: ({ product }: { product: ProductUnion }) => product.hasReceivedAdministrativeDecision !== true,
    isClickable: ({ product }: { product: ProductUnion }) => product.hasReceivedAdministrativeDecision !== true,
    showInBoard: true,
  },
  [STAGE_ADMINISTRATIVE_DECISION_ISSUED]: {
    label: "Bescheid erlassen",
    stage: STAGE_ADMINISTRATIVE_DECISION_ISSUED,
    leadStatus: status.STATUS_ADMINISTRATIVE_DECISION_ISSUED,
    isActive: ({ product }: { product: ProductUnion }) => product.hasFiledObjectionToAdministrativeDecision !== true,
    isClickable: ({ product }: { product: ProductUnion }) => product.hasFiledObjectionToAdministrativeDecision !== true,
    showInBoard: true,
  },
  [STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]: {
    ...baseStageMetaDataCase[STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT],
    label: "Widerspruch eingelegt",
  },
  [STAGE_EXTRAJUDICIAL_REACTION_RECEIVED]: {
    ...baseStageMetaDataCase[STAGE_EXTRAJUDICIAL_REACTION_RECEIVED],
    label: "Reaktion der Behörde auf Widerspruch",
  },
};
